import { Banner } from "components/DesignSystem/Banner/Banner";
import { useHistory, useParams } from "react-router-dom";
import { pluralize } from "utils/pluralize";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useGetEntityOverviewQuery } from "v2/store/entityDocumentsApi";
import { Button } from "components/DesignSystem/Button/Button";
import { CLICKED_VIEW_IN_UNSORTED_ON_RECORDS_AND_SETUP } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";

export const UnmatchedFilesBanner = () => {
  const { entityId = "" } = useParams<{ entityId: string }>();
  const history = useHistory();
  const { unsorted_folder_id } = useCurrentGroupContext();
  const { trackEvent } = useAnalytics();

  const { data } = useGetEntityOverviewQuery({ entityId });

  const unmatchedCount = data?.unmatchedCount ?? 0;

  const handleViewInOthers = (): void => {
    trackEvent(CLICKED_VIEW_IN_UNSORTED_ON_RECORDS_AND_SETUP, {
      unmatched_count: unmatchedCount,
    });
    if (unsorted_folder_id) history.push(`/documents/${unsorted_folder_id}`);
  };

  if (unmatchedCount === 0) return null;

  return (
    <div className="t-mb-4">
      <Banner
        type="info"
        title={`${pluralize(
          unmatchedCount,
          "file",
          "files"
        )} couldn't be matched`}
        description="These files don't match any existing category and have been placed in the Unsorted folder for review."
        cta={
          <Button size="small" type="button" onClick={handleViewInOthers}>
            View in Unsorted
          </Button>
        }
      />
    </div>
  );
};
